<template>
  <div class="fieldset-favorite-team-parts">
    <label>
      <span class="label-text">{{ $tc('SignupPage.FormInput.FavoriteTeam') }}</span>
      <span v-if="required" class="required">{{ $tc('formParts.required') }}</span>
    </label>

    <div class="fieldset-favorite-team-parts__current-view">
      <team-card-parts :name="name" :img="img" />
    </div>

    <template v-if="name">
      <div class="fieldset-favorite-team-parts__link">
        <atom-router-button
          :to="linkTo"
          :linkText="$t('MypagePage.MypageTopPage.favoriteTeamChange')"
          colorType="tertiary"
        />
      </div>
    </template>
    <template v-else>
      <router-link :to="linkTo" class="fieldset-favorite-team-parts__selector">
        <figure class="fieldset-favorite-team-parts__selector__img">
          <img src="assets/img/common/card/icon_team__green.svg" alt="" />
        </figure>

        <div class="fieldset-favorite-team-parts__selector__message">
          <p class="fieldset-favorite-team-parts__selector__text">
            {{ $tc('SignupPage.FormInput.FavoriteTeamSelectorText') }}
          </p>
          <p class="fieldset-favorite-team-parts__selector__caption">
            {{ $tc('SignupPage.FormInput.FavoriteTeamSelectorCaption') }}
          </p>
        </div>

        <svg
          class="fieldset-favorite-team-parts__selector__arrow"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.70709 2.58545L15.7071 10.5854C16.4881 11.3665 16.4881 12.6328 15.7071 13.4139L7.70709 21.4139L7.70709 18.5854L14.2929 11.9997L7.70709 5.41388L7.70709 2.58545Z"
            fill="#808080"
          />
        </svg>
      </router-link>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import TeamCardParts from '@/components/common/card/TeamCardParts.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'

/**
 * フィールドセット お気に入りチーム選択 バーツ
 * todo: デザイン調整 / チーム選択ページ遷移処理 / props設定 / エラー表示 / emit等
 */
export default defineComponent({
  name: 'FieldsetFavoriteTeamParts',
  components: {
    TeamCardParts,
    AtomRouterButton,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * 遷移先リンク
     */
    linkTo: {
      type: String,
      required: true,
    },
    /**
     * お気に入りチーム名
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * お気に入りチーム画像
     */
    img: {
      type: String,
    },
  },
})
</script>

<style lang="scss" scoped>
.fieldset-favorite-team-parts {
  @include fieldSet();

  &__current-view {
    width: 100%;
  }

  &__selector {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    width: calc(100% + 32px);
    padding: 16px;
    margin: 16px -16px 0;
    border-top: 1px solid rgba(#000, 10%);
    border-bottom: 1px solid rgba(#000, 10%);
    font-weight: 500;
    font-size: 10px;
    line-height: 1.4;
    letter-spacing: 0.04em;
    font-feature-settings: 'palt' on;
    color: $gray50;

    &__message {
      width: calc(100% - 98px);
      text-align: left;
    }

    &__text {
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 0.02em;
      color: $black;
    }
  }

  &__link {
    width: 100%;
    margin-top: 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0;
    color: $black80;
  }
}
</style>
